var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"construction_standard"},[_c('AntGridSkeleton',{attrs:{"height":"15rem","num":8,"rows":1,"gap":1,"loading":_vm.loading}},[_c('Swipers',{attrs:{"data":_vm.data,"submit":_vm.submit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }